module.exports = __webpack_public_path__ + "static/img/salam-takaful.3a2e548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/salam-takaful.png
// module id = ILdU
// module chunks = 1